import moment from "moment/moment"

import { getCurrentTime, parseDate } from "../../../../shared_components/utils"

const getFieldAndObject = (state, action) => {
  let fieldName = ""
  let editFields = []
  if (action.field === "runs") {
    editFields = Object.assign([], state.runs)
    fieldName = "runs"
  } else if (action.field === "stocks") {
    editFields = Object.assign([], state.stocks)
    fieldName = "stocks"
  } else if (action.field === "external_samples") {
    editFields = Object.assign([], state.external_samples)
    fieldName = "external_samples"
  } else if (action.field === "external_runs") {
    editFields = Object.assign([], state.external_runs)
    fieldName = "external_runs"
  } else {
    console.error("getFieldAndObject: Field and object not found.")
  }

  return [fieldName, editFields]
}

export const inoFormReducer = (state, action) => {
  switch (action.type) {
    case "field": {
      return {
        ...state,
        [action.field]: action.value,
      }
    }
    case "listField": {
      const [fieldName, editFields] = getFieldAndObject(state, action)
      let field_info = { ...editFields[action.index] }
      field_info[action.sub_field] = action.value

      if (action.sub_field === "instance") {
        field_info["count"] = 1
      }

      field_info["complete"] = Object.keys(field_info["instance"]).length > 0 && field_info["count"] !== ""
      editFields[action.index] = field_info

      return {
        ...state,
        [`${fieldName}`]: editFields,
      }
    }
    case "row": {
      const [fieldName, editFields] = getFieldAndObject(state, action)
      editFields.push({ instance: {}, count: 1, complete: false })
      return {
        ...state,
        [`${fieldName}`]: editFields,
      }
    }
    case "removeRow": {
      const [fieldName, editFields] = getFieldAndObject(state, action)
      editFields.splice(action.index, 1)
      return {
        ...state,
        [`${fieldName}`]: editFields,
      }
    }
    case "clear": {
      return {
        ...state,
        ...action.value,
      }
    }
    case "submit": {
      return {
        ...state,
        ...action.value,
        isLoading: true,
      }
    }
    case "invalidForm": {
      return {
        ...state,
        isLoading: false,
      }
    }
  }
}

export const getTimestamp = (ts) =>
  parseDate(ts) ? moment(parseDate(ts)).format("YYYY-MM-DDTHH:mm:ss") : null
export const getCurrentTimestamp = () => moment(getCurrentTime()).format("YYYY-MM-DDTHH:mm:ss")

// ___ is a special substring we have to not let people use here (backend incompatibility)
export const cleanSubstring = (val) => val.replace("___", "_")

export const toSelectArray = (value) => {
  if (Array.isArray(value)) {
    return value.filter(Boolean).map((o) => cleanSubstring(o))
  }

  if (typeof value !== "string" || !value) {
    return []
  }

  return [cleanSubstring(value)]
}
